import React from "react";
import SinglePillarContent from "@/components/nds/windows/pillar/SinglePillarContent";

export default function Pillar1InnerContent({ win }) {
  return <SinglePillarContent pillarId="PILLAR_1_INNER" focus={win?.payload?.focus} />;
}
